export default {
  name: 'banner',
  components: {},
  props: { 
     content: Object,
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
